<template>
	<div>
		<video
			ref="videoPlayer"
			class="video-js vjs-default-skin vjs-big-play-centered"
		></video>
	</div>
</template>
<style scoped>
.video-js {
	width: 100%;
	height: 100vh;
}
</style>
<script>
import videojs from "video.js";
import "video.js/dist/video-js.min.css";
window.videojs = videojs;
require("videojs-contrib-hls/dist/videojs-contrib-hls.js");
require("videojs-youtube/dist/Youtube.js");

export default {
	name: "VideoPlayer",
	props: {
		options: {
			type: Object,
			default() {
				return {};
			},
		},
	},
	data() {
		return {
			player: null,
		};
	},
	mounted() {
		this.player = videojs(
			this.$refs.videoPlayer,
			this.options,
			function onPlayerReady() {
			}
		);
	},
	beforeDestroy() {
		if (this.player) {
			this.player.dispose();
		}
	},
};
</script>
